import React, { Component } from 'react';
import ChapterList from '../containers/ChapterList/ChapterList';
import { connect } from 'react-redux';

// class Chapters extends Component {
//
//     render() {
const Chapters = props => {
    let courseName = "Название книги";

    if (props.chapters.chaptersList.length !== 0) {
        courseName = props.chapters.chaptersList[0]["text"];
    }



    return (
        <div className="aside-menu-content"
        // style={{background: 'red'}}
        >
            <div id="content-top"></div>
            <div className="book-title">
                {courseName}
            </div>

            <ChapterList
                currentItem={props.content}
            />

        </div>
    );
};
//         );
//     }
// }

// function mapStateToProps(state) {
//     return {
//         chapters: state.chapters
//     };
// }
//
// export default connect(mapStateToProps)(Chapters);
export default Chapters;




// WEBPACK FOOTER //
// ./src/components/Chapters.js